import cc from "classcat"

const Price = ({ price, comment = "", className }) => {
  // const [whole = 0, fraction = ""] = price.split(",")
  return (
    <div className={cc(["flex items-end justify-center", className])}>
      <div>
        <p className="m-0 mr-1 font-body text-5xl font-extrabold leading-none">
          {price}
        </p>
      </div>
      <div className="flex flex-col">
        {/* <p className="m-0 text-2xl font-extrabold leading-tight">{fraction}</p> */}
        <p className="m-0 text-xl">{comment}</p>
      </div>
      {/* {postfix && <div className={styles.postfix}>{postfix}</div>} */}
    </div>
  )
}

export default Price
